export default __webpack_public_path__ + "static/media/wifi.eb984368.svg";